// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {getMainParentRouteName} from "@/lib/lib";
import {getUnitDefaultRouteParams} from "@/router/prometheus/portal/units";
import store from "@/store";
const pageClass = 'units-groups-page';
const routeParams = {
    groups: (route) => {
        return {
            name: consts.routerNames.units_groups.groups.main,
            params: {},
            query: {...route.query}
        }
    },
    geozones: (route) => {
        return {
            name: consts.routerNames.units_groups.geozones,
            params: {},
            query: {...route.query}
        }
    },
}
const defaultSetRoute = {
    unitId: (route, router, unitId, date, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if (consts.app.$isDevelopment) console.warn('unitId', route);
            return false;
        }

        let routeParams = getUnitDefaultRouteParams(unitId, template)
        date = date || route?.params?.date || store.getters.getDateToday

        router.push({
            name: routeParams?.routeName?.date || consts?.routerNames?.units?.id,
            params: {
                ...routeParams?.params,
                date,
            },
            query: {}
        })
    },
    groupEdit: (route, router, groupId, action) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if(consts.app.$isDevelopment) console.warn('groupId', route);
            return false;
        }

        router.push({
            name: consts.routerNames.units_groups.edit,
            params: {
                groupId,
                action: action || (groupId ? 'edit' : 'create')
            },
            query: {...route.query}
        })
    },
    unitInfo: (route, router, unitId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if(consts.app.$isDevelopment) console.warn('unitId', route);
            return false;
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        router.push({
            name: routeParams.routeName.info,
            params: {
                ...routeParams.params
            },
            query: {}
        })
    },
    group: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if(consts.app.$isDevelopment) console.warn('units_groups', route);
            return false;
        }

        let query = route.query
        delete query.groupsIds

        router.push({
            name: consts.routerNames.units_groups.main,
            params: {
                groupId
            },
            query
        })
    },
    groups: (route, router) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if(this.$isDevelopment) console.warn('units_groups', route);
            return false;
        }

        router.push(routeParams.groups(route))
    },
    groupMap: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if(consts.app.$isDevelopment) console.warn('units_groups', route);
            return false;
        }
        router.push({
            name: consts.routerNames.units_groups.map,
            params: {
                groupId
            },
            query: {...route.query}
        })
    },
    multipleGroups(route, router, groupsIds) {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if(consts.app.$isDevelopment) console.warn('units_groups', route);
            return false;
        }
        router.push({
            name: consts.routerNames.units_groups.main,
            params: {
                groupId: null,
            },
            query: {
                ...route.query,
                groupsIds
            }
        })
    },
    unitsGroupsFilter: (route, router, filter) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if(consts.app.$isDevelopment) console.warn('unitsFilter', route);
            return false
        }
        router.push({
            name: route.name,
            params: {
                ...route.params
            },
            query: {
                name: filter?.name || undefined,
                color: filter?.color || undefined,
                groupIds: filter?.groupIds || undefined,
                battery: filter?.battery ? 'low-battery' : undefined,
            }
        })
    },
    md: (route, router, groupId) => {
        // if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
        //     if(consts.app.$isDevelopment) console.warn('md', route);
        //     return false
        // }
        router.push({
            name: consts.routerNames.md.fleet.main,
            params: {
                groupId
            },
            query: {
            }
        })
    },
    returnToParent: (route, router) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if(consts.app.$isDevelopment) console.warn('returnToParent', route);
            return false
        }
        router.push({
            name: route.meta.parentRouteName,
            params: {
                ...routeParams,
            },
            query: {
                ...route.query
            }
        })
    },
    unitsGroupGeozone: (route, router, geozoneId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if(consts.app.$isDevelopment) console.warn('unitsGroupGeozone', route);
            return false
        }
        router.push({
            name: consts.routerNames.units_groups.groups.geozone,
            params: {
                geozoneId
            },
            query: {
                ...route.query
            }
        })
    },
    unitsGroupUnit: (route, router, unitId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units_groups.main) {
            if(consts.app.$isDevelopment) console.warn('unitsGroupUnit', route);
            return false
        }
        router.push({
            name: consts.routerNames.units_groups.groups.unitId,
            params: {
                unitId
            },
            query: {
                ...route.query
            }
        })
    },
}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal') ? [] : [
    {
        path: 'units-groups/:pathMatch(.*)?',
        name: consts.routerNames.units_groups.main,
        redirect: () => {
            let key = store.getters.getUserStorageKey + '.units-groups.groupIds'
            let groupIds = localStorage.getItem(key) || null
            let query = groupIds ? {groupIds} : {}
            return {
                name: consts.routerNames.units_groups.groups.main,
                query
            }
        },
        meta: {
            // list: 'UnitsList',
            showMap: true,
            mainRouteName: consts.routerNames.units_groups.main,
            pageClass,
            routeParams,
            layers: {
                ...consts.defaultSettingsLayers,
                units: {visible: false, showInList: false, showLayer: false},
                units_groups: {visible: true, showInList: false, showLayer: true},
                geoitems: {visible: false, showInList: true, showLayer: true},
            },
            setRoute: defaultSetRoute,
        },
        props: {
            default: (route) => {
                let key = store.getters.getUserStorageKey + '.units-groups.groupIds'
                let groupIds = route?.query?.groupIds || localStorage.getItem(key) || null
                return {
                    groupIds: groupIds?.split(',').map(gid => +gid) || [],
                    unitId: (route?.params?.unitId ? (+route?.params?.unitId) : undefined),
                }
            }
        },
        components: {
            default: () => import('@/views/prometheus/portal/UnitsGroupsPage.vue')
        },
        children: [
            {
                path: 'groups',
                name: consts.routerNames.units_groups.groups.main,
                meta: {
                    mainRouteName: consts.routerNames.units_groups.main,
                    parentRouteName: consts.routerNames.units_groups.main,
                },
                children: [
                    {
                        path: 'geozone/:geozoneId(\\d+)',
                        name: consts.routerNames.units_groups.groups.geozone,
                        meta: {
                            mainRouteName: consts.routerNames.units_groups.main,
                            parentRouteName: consts.routerNames.units_groups.groups.main,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: false, showInList: false, showLayer: false},
                                units_groups: {visible: true, showInList: false, showLayer: true},
                                geoitem_edit: {visible: true, showInList: true, showLayer: true},
                            },
                        },
                    },
                    {
                        path: ':unitId(\\d+)',
                        name: consts.routerNames.units_groups.groups.unitId,
                        meta: {
                            mainRouteName: consts.routerNames.units_groups.main,
                            parentRouteName: consts.routerNames.units_groups.groups.main,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: false, showInList: false, showLayer: false},
                                units_groups: {visible: true, showInList: false, showLayer: true},
                                geoitem_edit: {visible: true, showInList: true, showLayer: true},
                            },
                        },
                    },
                ]
            },
            {
                path: 'geozones',
                name: consts.routerNames.units_groups.geozones,
                meta: {
                    mainRouteName: consts.routerNames.units_groups.main,
                    parentRouteName: consts.routerNames.units_groups.main,
                },
            },
            {
                path: 'edit/:groupId(\\d+)?/:action(create|edit)',
                name: consts.routerNames.units_groups.edit,
                meta: {
                    mainRouteName: consts.routerNames.units_groups.main,
                    blockingRoutesTransitionFromOutside: true,
                    pageClass: [pageClass, pageClass+'__edit'].join(' '),
                    showMap: false,
                },
                props: {
                    default: (route) => {
                        return {
                            groupId: route?.params?.groupId,
                            action: route?.params?.action
                        }
                    }
                },
                components: {
                    default: () => import("@/components/units-groups/UnitsGroupEdit.vue"),
                }
            },
        ]
    },
];

export default routes;